var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.468,
    height: 12.02,
    viewBox: "0 0 14.468 12.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list",
    d: "M2.5,13.907a.612.612,0,0,1,.612-.612H15.356a.612.612,0,1,1,0,1.224H3.112A.612.612,0,0,1,2.5,13.907Zm0-4.9A.612.612,0,0,1,3.112,8.4H15.356a.612.612,0,1,1,0,1.224H3.112A.612.612,0,0,1,2.5,9.01Zm0-4.9A.612.612,0,0,1,3.112,3.5H15.356a.612.612,0,1,1,0,1.224H3.112A.612.612,0,0,1,2.5,4.112Z",
    transform: "translate(-2 -3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic_more.d85e1c691cb76d8b28c30c903a6b395d.svg";
export { ForwardRef as ReactComponent };